export default {
    forgot_password_username: 'Nombre de usuario',
    forgot_password_username_placeholder: 'Introduzca su nombre de usuario o correo electrónico',
    forgot_password_have_a_code: 'Tengo un código',
    forgot_password_vefification_code: 'Código de verificación',
    forgot_password_resend: 'Reenviar',
    forgot_password_dont_receive_the_code: '¿No ha recibido el código?',
    forgot_password_new_password: "Nueva contraseña",
    forgot_password_repeat_new_password: "Repetir la nueva contraseña",
    forgot_password_password_recovery: "Recuperar contraseña",
    forgot_password_verify_user: "Verifique el nombre de usuario introducido y vuelva a intentarlo.",
    forgot_password_the_password_has_been_changed: "La contraseña ha sido cambiada. Ahora puede conectarsen",
    forgot_password_limit: "Límite de intentos excedido, por favor inténtelo después de algún tiempo",
    forgot_password_message: "Se enviara un correo electrónico a su dirección de correo electrónico con un enlace para restablecer su contraseña",
    forgot_password_message_success: "Se ha enviado un correo electrónico a su dirección de correo electrónico con un enlace para restablecer su contraseña",
};